<div class="upload-container">
	<div
		class="drop-area"
		(click)="fileInput.click()"
		appDropFile
		(filesDropped)="addFile($event)"
		*ngIf="!(hideDropAreaAfterFilesAdded && files?.length) || !hideDropAreaAfterFilesAdded"
	>
		<p i18n="Drag and Drop Instructions@@fileUploaderDragAndDropFilesInstructionsText">Drag and Drop files here or click to pick a file.</p>
		<span [innerHTML]="instructions" *ngIf="instructions"></span>
		<input hidden type="file" multiple #fileInput (change)="addFile($event.target['files'])" />
	</div>
	<mat-accordion *ngIf="automaticUpload && files?.length" class="auto-upload-summary">
		<mat-expansion-panel [expanded]="remainingCount > 0">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{ automaticUploadStatusMessage || ('Uploaded ' + uploadedCount + ' ' + (uploadedCount === 1 ? 'file' : 'files')) }}
				</mat-panel-title>
				<mat-panel-description>
					{{ uploadedCount }} / {{ totalFiles }} uploaded
				</mat-panel-description>
			</mat-expansion-panel-header>
			<div class="auto-upload-list">
				<div class="auto-upload-item" *ngFor="let file of files">
					<mat-icon class="auto-upload-status"
						[ngClass]="{
							uploaded: file.uploaded,
							uploading: file.uploading && !file.uploaded,
							pending: !file.uploaded && !file.uploading,
							error: file.error
						}">
						{{ file.uploaded ? 'check_circle' :
						   file.error ? 'error' :
						   (file.uploading ? 'cloud_upload' : 'schedule') }}
					</mat-icon>
					<div class="auto-upload-file-info">
						<span class="auto-upload-file-name" [matTooltip]="file.title">{{ file.title }}</span>
						<mat-progress-bar
							*ngIf="file.uploading && !file.uploaded && !file.error"
							mode="determinate"
							[value]="file.progress || 0"
							class="file-progress-bar">
						</mat-progress-bar>
					</div>
					<span class="auto-upload-state" *ngIf="file.uploading && !file.uploaded && !file.error">
						{{ file.progress || 0 }}%
					</span>
					<span class="auto-upload-state uploaded" *ngIf="file.uploaded">Uploaded</span>
					<span class="auto-upload-state error" *ngIf="file.error" [matTooltip]="file.error">Failed</span>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
	<div class="upload-container--content">
		<p *ngIf="files?.length && !automaticUpload" i18n="File Uploader Instructions@@fileUploaderInstructionsText">Fill out the title and description and then hit the upload button on each file.</p>
		<div *ngIf="files?.length && !automaticUpload" class="file-list">
			<div *ngFor="let file of files" class="file">
				<div class="file-name-logo-container">
					<ng-container [ngSwitch]="file.category">
						<mat-icon *ngSwitchCase="'image'">image</mat-icon>
						<mat-icon *ngSwitchCase="'music'">music_video</mat-icon>
						<mat-icon *ngSwitchCase="'voice'">mic</mat-icon>
						<mat-icon *ngSwitchCase="'video'">video_library</mat-icon>
						<mat-icon *ngSwitchDefault>help</mat-icon>
					</ng-container>

					<mat-form-field class="no-bottom-padding" appearance="fill" floatLabel="always">
						<mat-label i18n="Form Label@@fileUploaderFileTitleLabel">Title</mat-label>
						<input matInput [value]="file.title" (change)="file.title = $event.target['value']" required [disabled]="file.uploaded" />
					</mat-form-field>
				</div>

				<mat-form-field class="no-bottom-padding" appearance="fill" floatLabel="always">
					<mat-label i18n="Form Label@@fileUploaderFileDescriptionLabel">Description</mat-label>
					<input
						matInput
						[value]="file.description || ''"
						(change)="file.description = $event.target['value']"
						[disabled]="file.uploaded"
					/>
				</mat-form-field>

				<mat-form-field *ngIf="!hideSaveToField" class="no-bottom-padding" appearance="fill" floatLabel="always">
					<mat-label i18n="Form Label@@fileUploaderFileSaveToLabel">Save To</mat-label>
					<mat-select [disabled]="file.uploaded" [value]="file.saveTo" (selectionChange)="file.saveTo = $event.value">
						<!-- <mat-option value="my-files"> My Files </mat-option> -->
						<mat-option value="dealer-files" *ngIf="business"> {{ (siteCopy$ | async)?.businessNameLabelSingular | titlecase }} <ng-container i18n="Files Option@@fileUploaderFilesOptionText">Files</ng-container></mat-option>
						<mat-option value="project-files" *ngIf="project" i18n="Project Files Option@@fileUploaderProjectFilesOptionText"> Project Files </mat-option>
						<mat-option value="all-files" *ngIf="isAdmin" i18n="All Files Option@@fileUploaderAllFilesOptionText"> All Files</mat-option>
					</mat-select>
				</mat-form-field>

				<app-business-selection-input
						class="business-input"
						*ngIf="isAdmin || (userBusinesses > 1)"
						label="Visible To Business"
						i18n-label="File Uploader Business Label@@fileUploaderDialogBusinessLabel"
						[multiple]="false"
						[showAllBusinesses]="true"
						[currentValue]="business"
						(valueChange)="updateBusinessAssociation($event, file)"
				></app-business-selection-input>


				<div class="buttons">
					<button mat-mini-fab color="primary" *ngIf="file.uploaded" disabled>
						<mat-icon>done</mat-icon>
					</button>

					<button
						mat-flat-button
						class="full-width"
						color="primary"
						*ngIf="!file.uploading && !file.uploaded"
						[disabled]="!file.title?.length"
						(click)="upload(file)"
						i18n="Upload Button@@fileUploaderUploadButtonLabel"
					>
						Upload
					</button>

					<button mat-mini-fab color="primary" *ngIf="file.uploading"><span class="gtb-loader"></span></button>
				</div>
			</div>
		</div>
	</div>

	<button *ngIf="showDoneButton" class="margin-left-auto full-width done-button" mat-flat-button color="primary" (click)="done()" i18n="Done Button@@fileUploaderDoneButtonLabel">Done</button>
</div>
